import type { ReactNode } from 'react';

import { WizardContextProvider } from './contexts/WizardContext';
import { WizardForm } from './WizardForm';
import type { WizardStep } from './types/step.type';
import type { WizardProps } from './types/props.type';

export type { WizardStep };

export const Wizard = <
  V extends object, // Values
  VS extends object, // Validation Schema
  SE, // Step Enum
>(
  props: Omit<WizardProps<V, VS, SE>, 'wizardChildren'> &
    Readonly<{
      children: ReactNode;
    }>,
) => {
  const { children: wizardChildren, ...otherProps } = props;

  const contextProps = {
    ...otherProps,
    wizardChildren,
  };

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <WizardContextProvider {...contextProps}>
      <WizardForm />
    </WizardContextProvider>
  );
};
